module["exports"] = [
  "ул.",
  "улица",
  "проспект",
  "пр.",
  "площадь",
  "пл."
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ru/address/street_suffix.js
// module id = 3486
// module chunks = 1609